import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

export interface ProtectedRouteProps extends PropsWithChildren<{}> {
  authStatus: string;
}

function ProtectedRoute(props: ProtectedRouteProps): JSX.Element {
  if (props.authStatus !== "AUTHENTICATED") {
    // not logged in so redirect to login page with the return url
    return <Navigate to="/login" />;
  }
  return props.children as JSX.Element;
}

export default ProtectedRoute;
